<template>

    <dropdown-search-menu :options="{
            inputIcon: 'far fa-building',
            placeholder: __('labels.company.select_or_create'),
            title_clear: __('labels.basics.clear')
        }"
        :keys="$store.state.companies.infinity.columns"
        :selectkeys="['name']"
        setref="companies"
        v-model:search="search"
        :selected="selValue"
        :values="values"
        :is-loading="companies_loading"
        @update:search="searchCompanies($event)"
        :selectElementOnUnfocus="this.selectOnUnfocus"
        @dropdown:new="$store.commit('users/addNew', true)"
        @dropdown:select="select"
        @dropdown:clear="clearValues()"
        @menu:loadmore="$store.dispatch('companies/load')"
        cy="companies"
        >
        <slot name="label" >

        </slot>
    </dropdown-search-menu>
</template>
<script>
export default {
    props: {
        value : {},
        selectOnUnfocus: {
            default: true,
            type: Boolean,
        }
    },
    components: {

    },
    setup() {

    },
    data() {
        return {
            search: "",
            selValue : "",
            selected: {
                name : "",
                id : 0,
            },
            debounce : {
                searchCompany : null,
            }
        }
    },
    mounted() {
        if(this.value && this.value.id){
            this.selected.id = this.value.id;
            this.selected.name = this.value.name;
            this.search = this.value.name;
        }
    },
    methods: {
        clearValues(){
            this.selValue = 0;
            this.selected.name ="";
            this.selected.id = null;
            this.search = "";
            this.$emit('update:value', this.selected)
            this.$emit("dropdown:clear"); // public
        },
        select(event, event2){
            this.selValue = event.id;
            this.selected.name = event.name;
            this.selected.id = event.id;
            this.search = event2;
            this.$emit('update:value', this.selected)  // public
        },
        searchCompanies(event) { // private
            if (this.debounce.searchCompany)
                clearTimeout(this.debounce.searchCompany);

            this.debounce.searchCompany = setTimeout(() => {
                this.$store.commit("companies/setSearch", event);
                this.$store.dispatch("companies/load");
            }, 300); // delay
        },
    },
    computed: {
        valTrue(){
            return true;
        },
        columns() {
            return this.$store.state.companies.infinity.columns
        },
        values() {
            return this.$store.state.companies.companies;
        },
        companies_loading() {
            return this.$store.state.companies.loading;
        },
    }
}
</script>
